'use memo';

import { Trans } from '../../adapters/i18next-trans';
import type { LegacyStringTFunction } from '../../adapters/i18next-types';

type UnescapedTransProps = Record<string, unknown> & {
  t?: LegacyStringTFunction;
};

/**
 * Unescapeが必要なユーザー入力を翻訳・補間するとき、明示的にshouldUnescapeをtrueにするコンポーネントです
 * Please see 【ADR】i18nにおけるエスケープ対応方針(文字化け防止)【2025-03】
 */
export const UnescapedTrans = ({ t, ...props }: UnescapedTransProps) => {
  return <Trans {...props} t={t} shouldUnescape={true} />;
};
